export const environment = {
  production: true,
  rootScope: null,
};
